export const API_URL = "https://our-state.com/api/";
export const UI_URL = "https://our-state.com";
export const ORIGIN = "our-state.com";
export const IS_PROD = false;
export const ETAG = "1793884431";
export const MONGONTURL = "https://our-state.com/api/MongoCommonNoToken/";
export const MONGOURL = "https://our-state.com/api/MongoCommon/";
export const SVCURL = "https://our-state.com/api/Common/";
export const NONCE = "JdBh8ASl/rMvyR2+NgLdfg";
export const SVCNTURL = "https://our-state.com/api/CommonNoToken/";
